import React from 'react';
import { Button, Flex, Table } from 'antd';
import { Content, Title } from 'components';
import { useNavigate } from 'react-router-dom';
import { strCut, stringToMoneyFormat } from 'utils';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';

const RefundList = (props) => {
  /* ===== Route ===== */
  const navigate = useNavigate();

  /* ===== Props ===== */
  const { data = [], isMobile } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <Content maxWidth={'100%'} height={320} borderRadius={4}>
      <Title
        size={5}
        style={{ marginBottom: 12, fontSize: isMobile ? 14 : 16 }}
        subButton={
          <Flex gap={4}>
            <Button
              size="small"
              onClick={() => navigate('/shipping/list/RETURN_REQUESTED')}
            >
              <ExportOutlined /> 환불/반품 목록
            </Button>
          </Flex>
        }
      >
        환불/반품 신청
      </Title>

      <Table
        bordered
        size="small"
        scroll={{ x: 'max-content', y: 210 }}
        // style={{ height: 300 }}
        pagination={false}
        dataSource={data.toSorted((a, b) => b.created_at - a.created_at)}
        columns={[
          {
            title: (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                신청(시간)
              </p>
            ),
            dataIndex: 'created_at',
            width: isMobile ? 100 : 200,
            align: 'center',
            render: (v) => (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                {dayjs(v * 1000).format(
                  isMobile ? 'YY.MM.DD (HH:mm)' : 'YYYY-MM-DD (HH:mm:ss)'
                )}
              </p>
            ),
          },
          {
            title: (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                환불사유
              </p>
            ),
            dataIndex: 'refund_reason',
            width: isMobile ? 200 : 500,
            align: 'center',
            render: (v) => (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                {strCut(v, isMobile ? 30 : 55)}
              </p>
            ),
          },
          {
            title: (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                환불금액
              </p>
            ),
            dataIndex: 'refund_amount',
            width: isMobile ? 100 : 300,
            align: 'center',
            render: (v) => (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                {stringToMoneyFormat(v)}
              </p>
            ),
          },
          {
            title: (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                환불수량
              </p>
            ),
            dataIndex: 'refund_num',
            width: isMobile ? 100 : 300,
            align: 'center',
            render: (v) => (
              <p
                style={{
                  lineHeight: '135%',
                  fontSize: isMobile ? '0.7em' : '1em',
                }}
              >
                {stringToMoneyFormat(v)}
              </p>
            ),
          },
        ]}
      />
    </Content>
  );
};

export default RefundList;
